import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import ChannelList from './ChannelList'
import NoChannel from './NoChannel'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

const ChannelsContainers = ({ accountType, setAccountType, containersData }) => {
  const {
    activeChannels,
    setIsOpenModalQR,
    setIsOpenModalWebWidget,
    loading,
    channels,
    getChannels,
    pendingChannels,
    onEdit,
    onDeleteModal,
    setIsOpenModalAddChannel
  } = containersData[accountType].data

  return (
    <div className='channels-containers'>
      <div className='channels-containers__tabs'>
        {Object.keys(containersData).map(channelType => (
          <div
            key={channelType}
            className={`channels-containers__tab ${channelType === accountType ? 'channels-containers__tab--active' : ''}`}
            onClick={() => setAccountType(channelType)}
          >
            <p>{I18n.t(containersData[channelType].name)}</p>
          </div>
        ))}
      </div>
      <div className='channels-containers__content'>
        <div className='section mb-4'>
          <div className='top-section'>
            <div className='title-section'>
              <h1>{I18n.t(containersData[accountType].name)}</h1>
              <legend>{I18n.t('channels_subtitle')}</legend>
            </div>
            {activeChannels.length > 0 && accountType !== 'personal' && (
              <>
                <div className='widget-button' onClick={() => setIsOpenModalQR(true)}>
                  <div className='widget-title-container'>
                    <div className='widget-title'>{I18n.t('channels_qr_creator')}</div>
                    <div className='widget-subtitle'>{I18n.t('channels_qr_widget_subtitle')}</div>
                  </div>
                  <div className='qr-image-container'>
                    <img src='img/illu-qr.svg' alt='qr'/>
                  </div>
                </div>
                <div className='widget-button' onClick={() => setIsOpenModalWebWidget(true)}>
                  <div className='widget-title-container'>
                    <div className='widget-title'>{I18n.t('channels_web_widget')}</div>
                    <div className='widget-subtitle'>{I18n.t('channels_web_widget_subtitle')}</div>
                  </div>
                  <div className='widget-image-container'>
                    <img src='img/illu-webchat.svg' alt='widget' />
                  </div>
                </div>
              </>
            )}
          </div>
          { loading ? (
            <Nixi1Spinner height='30px' width='30px'/>
          ) : channels.length > 0
            ? (
              <div>
                {activeChannels.length > 0 &&
                  <ChannelList channels={activeChannels} getChannels={getChannels} onEdit={onEdit} onDelete={onDeleteModal}/>
                }
                {pendingChannels.length > 0 &&
                  <div className='pending'>
                    <div className='title-section'>
                      <h1>{I18n.t('configuration_not_active_channels_title')}</h1>
                    </div>
                    <ChannelList channels={pendingChannels} getChannels={getChannels} onEdit={onEdit} onDelete={onDeleteModal} pending/>
                  </div>
                }
                <div className='button-add-channel-plus' onClick={() => setIsOpenModalAddChannel(true)}>
                  <img src={getStaticImage('/icons/orange-brand/icon-add.svg')} alt='Add channel'/>
                  <span>{I18n.t('dashboard_add-channel')}</span>
                </div>
              </div>
            ) : (
              <NoChannel onClick={() => setIsOpenModalAddChannel(true)}/>
            )
          }
        </div>
      </div>
    </div>
  )
}

export { ChannelsContainers }
